{
  "$id": "wealthlane://forms/share-pool",
  "$schema": "wealthlane://schemas/form-model",
  "domain": "../share-pool.domain.json",
  "properties": {
    "id": {
      "$ref": "module://share-pool#properties/id"
    },
    "poolName": {
      "$ref": "module://share-pool#properties/poolName",
      "required": true
    },
    "poolTypeId": {
      "$ref": "module://share-pool#properties/poolTypeId",
      "required": true,
      "actionId": "FETCH_POOL_TYPE_OPTIONS",
      "dependsOn": []
    },
    "numberOfSharesAuthorised": {
      "$ref": "module://share-pool#properties/numberOfSharesAuthorised",
      "required": true
    },
    "numberOfSharesUnAvailable": {
      "$ref": "module://share-pool#properties/numberOfSharesUnAvailable",
      "required": true
    },
    "numberOfSharesAvailable": {
      "$ref": "module://share-pool#properties/numberOfSharesAvailable",
      "required": true,
      "readOnly": true
    },
    "eligibleShareClass": {
      "$ref": "module://share-pool#properties/eligibleShareClass",
      "required": true
    },
    "stockClassId": {
      "$ref": "module://share-pool#properties/stockClassId",
      "actionId": "FETCH_SHARE_POOL_STOCK_CLASS_OPTIONS",
      "dependsOn": []
    },
    "description": {
      "$ref": "module://share-pool#properties/description"
    },
    "isTransferAgentActive": {
      "$ref": "module://share-pool#properties/isTransferAgentActive"
    },
    "hasExternalPoolRefrence": {
      "$ref": "module://share-pool#properties/hasExternalPoolRefrence",
      "required": true,
      "hiddenWhen": {
        "field": "isTransferAgentActive",
        "notEquals": true
      }
    },
    "externalPoolName": {
      "$ref": "module://share-pool#properties/externalPoolName"
    },
    "externalPoolReferenceId": {
      "$ref": "module://share-pool#properties/externalPoolReferenceId",
      "required": true,
      "actionId": "FETCH_VINYL_EXTERNAL_RESERVE_POOL_OPTIONS",
      "dependsOn": ["isTransferAgentActive", "hasExternalPoolRefrence"],
      "hiddenWhen": {
        "field": "hasExternalPoolRefrence",
        "notEquals": true
      },
      "clearOnHideWhen": true
    }
  },
  "dataSource": {
    "submit": {
      "actionId": "SAVE_SHARE_POOL",
      "refreshEntities": ["Share Pool"],
      "invalidateQueries": ["getSharePoolList", "dt-v2-page"]
    }
  },
  "modes": {
    "create": {
      "dataSource": {
        "submit": {
          "successMessage": "Share Pool Added"
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "edit": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_SHARE_POOL_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        },
        "submit": {
          "successMessage": "Share Pool Edited"
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "view": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_SHARE_POOL_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "viewPresentation": "disabled-inputs"
    }
  }
}
